/*
 * @Author: wp
 * @Date: 2023-01-10 16:24:14
 * @Descripttion:
 */
import qs from 'qs-stringify'
import env from '~/env'
const packageJson = require('../package.json')
import { getSignature } from '@/utils/sign'
import { httpErrorStatusHandle } from '@/utils/statusTip'

export default ({ $axios, store, $cookies, req }, inject) => {
	const _config = {
		baseURL: env[packageJson.env].ENV_API,
		timeout: 30 * 1000,
		withCredentials: true
	}
	const service = $axios.create(_config)
	//请求拦截
	service.interceptors.request.use(
		async config => {
			if (config.data) {
				service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
				service.defaults.headers.post['x-oss-forbid-overwrite'] = true
			}
			let param = {}
			if (config.method == 'get') {
				param = await getSignature(config.params)
			} else {
				param = await getSignature(config.data, 'post')
			}
			const _token = store.getters['user/token']
			const token = $cookies.get('pzdsCookie') || _token

			if (_token && process.client) {
				$cookies.set('pzdsCookie', token)
			}
			if (token) {
				config.headers.token = token
			}

			if (process.client) {
				const _pzfrom = $cookies.get('pzfrom') || store.getters['pzfrom']
				// 百度渠道
				let c_vid = typeof $cookies.get('bd_vid') == 'string' ? $cookies.get('bd_vid').split('d')[0] : $cookies.get('bd_vid')
				let v_vid = typeof store.getters['bd_vid'] == 'string' ? store.getters['bd_vid'].split('d')[0] : store.getters['bd_vid']
				let _vid = c_vid || v_vid
				// 360渠道
				const _qhId = $cookies.get('qhclickid') || store.getters['qhclickid']
				//360渠道
				const _qhzs = $cookies.get('sourceid') || store.getters['sourceid']
				// 神马渠道
				const _SM = $cookies.get('uctrackid') || store.getters['uctrackid']
				// 微博渠道
				const _wb = $cookies.get('markId') || store.getters['markId']
				// searchWord
				const _sd = $cookies.get('keyword') || store.getters['keyword']
				// 判断什么渠道
				let channelName = null
				if (_vid) {
					channelName = 'BAIDU'
				} else if (_qhId) {
					channelName = 'QIHU'
				} else if (_SM) {
					channelName = 'SM'
				} else if (_wb) {
					channelName = 'WEIBO'
				} else if (_qhzs) {
					channelName = 'QIHU_ZS'
				}
				config.headers['channelInfo'] = JSON.stringify({
					channelCode: _pzfrom,
					tag: _vid || _qhId || _SM || _wb || _qhzs,
					channelType: channelName,
                    searchWord: encodeURIComponent(_sd),
                    adExtras: sessionStorage.ad_extras || '',
                    urlParam: $cookies.get('urlParam') || store.getters['urlParam'] || ''
				})
			}

			if (process.client) {
				$cookies.set('pzfrom', store.getters['pzfrom'])
				$cookies.set('bd_vid', store.getters['bd_vid'])
				$cookies.set('qhclickid', store.getters['qhclickid'])
				$cookies.set('sourceid', store.getters['sourceid'])
				$cookies.set('uctrackid', store.getters['uctrackid'])
				$cookies.set('markId', store.getters['markId'])
				$cookies.set('keyword', store.getters['keyword'])
			}

			config.headers['PZPlatform'] = 'pc'
			if (process.client) {
				let setuserinfo = JSON.parse(localStorage.getItem('setuserinfo'))
				if (setuserinfo) {
					config.headers['PZid'] = JSON.parse(localStorage.getItem('setuserinfo')).id
				}
			}
			config.headers['PZOs'] = store.getters['operatingSystem']
			config.headers['PZVersion'] = packageJson.version
			config.headers['PZVersionCode'] = '1'
			config.headers['Skey'] = process.client ? 'CLIENT' : 'SERVER'
			config.headers['Sign'] = param.strMd5
			config.headers['PZTimestamp'] = param.Timestamp
			config.headers['Random'] = param.Random
			// config.headers['signSkip'] = true
			if (config.method === 'post') {
				// config.data = config.data ? { ...config.data } : config.data
				switch (config.url) {
					case '/login':
					case '/code-login':
					case '/third-login':
						config.data = qs(config.data)
						break
					default:
					// config.data = JSON.parse(JSON.stringify(config.data))
				}
			} else {
				config.params = { ...config.params }
			}

			return config
		},
		error => {
			// 对请求错误做些什么
			return Promise.reject(error)
		}
	)
	//响应拦截
	service.interceptors.response.use(
		response => {
			// 判断是客户端渲染才执行此逻辑，不然在服务端会报 找不到 localStorage
			if (process.client && response.data.code === 'NOT_LOGGED_IN') {
				store.dispatch('user/UserResetToken')
			}
			return response.data
		},

		err => {
			// 401错误处理 - 记录错误接口地址并返回默认数据
			if (err.response && err.response.status === 401) {
				console.error('401 Unauthorized Error, API URL:', err.config.url);
				if (process.client) {
					store.dispatch('user/UserResetToken')
				}
				// 返回一个写死的数据
				return Promise.resolve({
					success: false,
					data: null,
					code: 'NOT_LOGGED_IN',
					info: '登录失效，请重新登录',
					requestId: null
				});
			}

			//返回数据
			httpErrorStatusHandle(err)
			return Promise.reject(err)
		}
	)

	//请求Api接口
	inject('requestApi', val => {
		//
		const { data, url, method } = val
		if (method === 'get' || method === 'GET') {
			return service({ url, method, params: data })
		} else if (url === '/web-client/v2/payment/arousal/query/pay/success') {
			return service({ url, method, params: data })
		} else if (method === 'post' || method === 'POST') {
			return service({ url, method, data })
		}
	})
}
